import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo/logo.png';

function Footer(props) {

  const [isVisible, setIsVisible] = useState(false);

  // ✅ Crypto payment state + navigation
  const [amount, setAmount] = useState('');
  const navigate = useNavigate();

  const handleCryptoPay = () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      alert('Enter a valid amount');
      return;
    }
    navigate(`/pay/crypto/${amount}`);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > 500);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <footer className="footer">
      <div className="shape"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="footer__main">
              {/* ✅ Crypto Payment UI */}
             <div className="text-center mb-12">
  <h3 className="text-4xl font-bold text-white mb-3">Make a Crypto Payment</h3>
  <p className="text-gray-300">Secure payment via USDT or Crypto Wallet</p>

  <div className="max-w-md mx-auto mt-6 flex flex-col sm:flex-row gap-4 justify-center items-center">
    <input
      type="number"
      placeholder="Enter Amount (USD)"
      value={amount}
      onChange={(e) => setAmount(e.target.value)}
      className="flex-1 w-full sm:w-auto p-3 rounded-lg border border-purple-600 text-white text-center text-lg placeholder-gray-400"
      style={{
        backgroundColor: '#1c1f3a', // 🔒 force dark background
        color: 'white',
        maxWidth: '200px'
      }}
    />

    <button
      onClick={handleCryptoPay}
      disabled={!amount || isNaN(amount) || Number(amount) <= 0}
      className="px-6 py-3 rounded-lg text-lg font-semibold transition-all duration-300 shadow-md"
      style={{
        background: amount && Number(amount) > 0
          ? 'linear-gradient(to right, #8b5cf6, #ec4899)' // purple to pink
          : '#aaa', // disabled bg
        color: amount && Number(amount) > 0 ? '#fff' : '#ccc',
        cursor: amount && Number(amount) > 0 ? 'pointer' : 'not-allowed'
      }}
    >
      Pay with Crypto
    </button>
  </div>
</div>
            </div>

            <div className="footer__bottom">
              <Link to="/" className="logo"><img src={logo} alt="Cyfonii" /></Link>

              <div className="center mb--30">
                <ul className="list">
  <li><Link to="/">Home</Link></li>
  <li><Link to="/explore">Explore</Link></li>
  <li><Link to="/about">About</Link></li>
  <li><Link to="/services">Services</Link></li>
  <li><Link to="/pricing">Pricing</Link></li>
  <li><Link to="/contact">Contact</Link></li>
</ul>
                <p>Copyright © 2022, PipPlus Tech. All rights reserved.</p>
              </div>

              <ul className="list-social">
                {/* your social icons remain unchanged */}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {isVisible && (
        <Link to="#" onClick={scrollToTop} id="scroll-top">
          <span className="icon-arrow-top"></span>
        </Link>
      )}
    </footer>
  );
}

export default Footer;
